<script lang="ts">
  import { EventTracking } from "@shared/services/event_tracking/events";

  const { trackClick } = EventTracking;

  export let isManualAccountNumberFlow: boolean;
  export let showConnectButton: boolean;
  export let showBackButton: boolean;
  export let continueButtonIsDisabled: boolean;
  export let connectButtonIsDisabled: boolean;
  export let getAccount: () => void;
  export let connect: () => void;
  export let resetAccount: () => void;
  export let submitWrapper: () => void;

  function handleConnectClick() {
    trackClick("connect_distributor_modal_connect_button");
    submitWrapper();
  }

  function handleConnectWithAccount() {
    trackClick("connect_distributor_modal_connect_button");
    connect();
  }
</script>

<footer class="modal__footer align-right padding--small">
  {#if isManualAccountNumberFlow}
    <div
      class="fizz-flex-row"
      class:fizz-space-between={showBackButton}
      class:fizz-justify-end={!showBackButton}
    >
      {#if showBackButton}
        <button class="fizz-button" on:click={resetAccount} data-testid="back-button">Back</button>
      {/if}
      <button
        class:fizz-button-secondary={!showConnectButton}
        class:fizz-button-primary={showConnectButton}
        disabled={continueButtonIsDisabled}
        on:click={showConnectButton ? handleConnectWithAccount : getAccount}
        data-testid="continue-button">{showConnectButton ? "Connect" : "Continue"}</button
      >
    </div>
  {:else}
    <div class="fizz-flex-row fizz-justify-end">
      <button
        class="button button--small button--primary button--label padding-right--medium padding-left--medium padding-top--smaller padding-bottom--smaller"
        disabled={connectButtonIsDisabled}
        on:click={handleConnectClick}
        data-testid="connect-button">Connect</button
      >
    </div>
  {/if}
</footer>
